export const CREATE_PRODUCT_IMAGE = 'productImages/CREATE_PRODUCT_IMAGE'
export const REMOVE_PRODUCT_IMAGE = 'productImages/REMOVE_PRODUCT_IMAGE'
export const FETCH_PRODUCT_IMAGES_LIST = 'productImages/FETCH_PRODUCT_IMAGES_LIST'
export const PRODUCT_IMAGES_LOADED = 'productImages/PRODUCT_IMAGES_LOADED'
